import React, { useCallback } from 'react';

import { LodControl } from '../lod-control';

/**
 * クオリティパネルのプロパティ
 */
export interface QualityPanelProps {
  /** パネルの表示状態 */
  visible: boolean;
  /** パネルを閉じるコールバック */
  onClose: () => void;
}

/**
 * クオリティパネルコンポーネント
 *
 * 画質調整のためのUIパネル（右側から表示）
 */
export function QualityPanel({ visible, onClose }: QualityPanelProps) {
  // 固定スタイル設定
  const containerBorderRadius = '16px';
  const headerPadding = '10px 15px';
  const headerHeight = '44px';
  const titleFontSize = '20px';
  const contentPadding = '16px';

  // 背景クリック時のハンドラー（背景がないので実際には呼ばれない）
  const handleBackdropClick = useCallback(
    (e: React.MouseEvent) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    },
    [onClose]
  );

  // パネルが非表示の場合は何も表示しない
  if (!visible) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        zIndex: 2000,
        pointerEvents: 'none' // 背景をクリックスルー
      }}
      onClick={handleBackdropClick}
    >
      <div
        style={{
          backgroundColor: 'white',
          height: 'calc(100% - 120px)',
          width: '400px',
          margin: '60px 90px 60px 0',
          borderRadius: containerBorderRadius,
          overflow: 'hidden',
          color: '#333',
          pointerEvents: 'auto', // パネル自体はクリック可能
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
          opacity: 1,
          fontFamily: 'sans-serif' // Tailwindのfont-sansを上書き
        }}
      >
        <div
          style={{
            padding: headerPadding,
            borderBottom: '1px solid #eee',
            height: headerHeight,
            position: 'relative'
          }}
        >
          <button
            style={{
              position: 'absolute',
              left: '15px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              padding: '0 5px',
              zIndex: 2,
              color: '#4C4948'
            }}
            onClick={onClose}
          >
            ×
          </button>
          <h2
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              margin: 0,
              fontSize: titleFontSize,
              fontWeight: 'bold',
              textAlign: 'center',
              zIndex: 1
            }}
          >
            設定
          </h2>
        </div>

        <div
          style={{
            padding: contentPadding,
            overflowY: 'auto',
            height: `calc(100% - ${headerHeight})`
          }}
        >
          <LodControl
            style={{
              position: 'static',
              width: '100%',
              margin: 0,
              backgroundColor: 'transparent',
              boxShadow: 'none',
              padding: '10px'
            }}
          />
        </div>
      </div>
    </div>
  );
}
